import type { IntlShape } from 'react-intl';
import { NewsroomPostType } from '@/types/newsroom';

/**
 * Builds the correct href for a post slug and type.
 * @param slug - The post slug
 * @param post_type - The type of post ('post', 'partner_list', etc.)
 * @returns The formatted href path
 * @example
 * buildPostHref('my-article', 'post') // returns '/press/my-article'
 * buildPostHref('partner-guide', 'partner_list') // returns '/partner-lists/partner-guide'
 */
export const buildPostHref = (slug?: string, post_type?: NewsroomPostType): string => {
  if (!slug || !post_type) {
    return '';
  }

  if (post_type === 'post') {
    return `/press/${slug}`;
  }
  if (post_type === 'partner_list') {
    return `/partner-lists/${slug}`;
  }
  return '';
};

/**
 * Converts a category slug to its display name.
 * @param intl - intl shape
 * @param categorySlug - The category slug to convert
 * @returns The human-readable category display name
 */
export const getCategoryDisplayName = (intl: IntlShape, categorySlug?: string): string => {
  switch (categorySlug) {
    case 'community':
      return intl.formatMessage({ defaultMessage: 'Community' });
    case 'company':
      return intl.formatMessage({ defaultMessage: 'Company' });
    case 'product':
      return intl.formatMessage({ defaultMessage: 'Product' });
    case 'trail-stories':
      return intl.formatMessage({ defaultMessage: 'Trail Stories' });
    default:
      return '';
  }
};
